import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import {
  getJsonSettingsByKey,
  getColumnOrder,
  TransferItem,
} from '../../../components/v2/table-settings-button'
import { calcTotalWidth } from '../../../../lib/utils/list'

export const useTableSettings = (addDataColumns: any[]) => {
  const { pathname } = useLocation()
  const jsonSettings = useSelector(state => getJsonSettingsByKey(state, pathname))

  const totalWidth = useMemo(() => calcTotalWidth(addDataColumns), [addDataColumns])

  const finalColumns = useMemo(
    () => addDataColumns.filter((item: any) => item.title),
    [addDataColumns],
  )

  const viewColumns = useMemo(() => {
    const order = getColumnOrder(jsonSettings)
    if (order.length > 0) {
      return order
        .map(setting => finalColumns.find((column: any) => setting === column.dataIndex))
        .filter(Boolean)
    }
    return finalColumns
  }, [finalColumns, jsonSettings])

  const settingsColumns = useMemo(
    () =>
      finalColumns.map(column => ({
        key: column?.['dataIndex'],
        title: column?.['title'],
      })),
    [finalColumns],
  ) as TransferItem[]

  return {
    totalWidth,
    viewColumns,
    settingsColumns,
  }
}
